// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.perxis-auto-1_16_0-header {
  /* Typography */
  --perxis-auto-header-font-family-inner: var(
    --perxis-auto-header-font-family,
    var(--perxis-auto-root-typography-small-font-family-inner)
  );
  --perxis-auto-header-font-size-inner: var(
    --perxis-auto-header-font-size,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  --perxis-auto-header-font-weight-inner: var(
    --perxis-auto-header-font-weight,
    var(--perxis-auto-root-typography-small-font-weight-inner)
  );
  --perxis-auto-header-letter-spacing-inner: var(
    --perxis-auto-header-letter-spacing,
    var(--perxis-auto-root-typography-small-letter-spacing-inner)
  );
  --perxis-auto-header-line-height-inner: var(
    --perxis-auto-header-line-height,
    var(--perxis-auto-root-typography-small-line-height-xxl-inner)
  );
  --perxis-auto-header-text-transform-inner: var(
    --perxis-auto-header-text-transform,
    var(--perxis-auto-root-typography-small-text-transform-inner)
  );
  /* End Typography */
  /* Colors */
  --perxis-auto-header-background-color-inner: var(
    --perxis-auto-header-background-color,
    var(--perxis-auto-root-first-color-inner)
  );
  /* End Colors */
  /* Shadow */
  --perxis-auto-header-shadow-inner: var(--perxis-auto-header-shadow, 0);
  /* End Shadow */
  /* Border */
  --perxis-auto-header-border-width-inner: var(--perxis-auto-header-border-width, 1px);
  --perxis-auto-header-border-color-inner: var(
    --perxis-auto-header-border-color,
    var(--perxis-auto-root-ninth-color-inner)
  );
  /* End Border */
  /* Padding */
  --perxis-auto-header-padding-inner: var(
    --perxis-auto-header-padding,
    var(--perxis-auto-gap-vertical-sky-inner) 18px var(--perxis-auto-gap-vertical-sky-inner) 18px
  );
  /* End Padding */
  background-color: var(--perxis-auto-header-background-color-inner);
  box-shadow: var(--perxis-auto-header-shadow-inner);
  border-bottom: var(--perxis-auto-header-border-width-inner) solid var(--perxis-auto-header-border-color-inner);
  font-family: var(--perxis-auto-header-font-family-inner);
  font-size: var(--perxis-auto-header-font-size-inner);
  line-height: var(--perxis-auto-header-line-height-inner);
  text-transform: var(--perxis-auto-header-text-transform-inner);
  letter-spacing: var(--perxis-auto-header-letter-spacing-inner);
  padding: var(--perxis-auto-header-padding-inner);
}
.perxis-auto-1_16_0-header.perxis-auto-1_16_0-header--without-border {
  border: 0;
}

.perxis-auto-1_16_0-header-parameters-toggler {
  /* Typography */
  --perxis-auto-header-parameters-toggler-font-family-inner: var(
    --perxis-auto-header-parameters-toggler-font-family,
    var(--perxis-auto-root-typography-small-font-family-inner)
  );
  --perxis-auto-header-parameters-toggler-font-size-inner: var(
    --perxis-auto-header-parameters-toggler-font-size,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  --perxis-auto-header-parameters-toggler-font-weight-inner: var(
    --perxis-auto-header-parameters-toggler-font-weight,
    var(--perxis-auto-root-typography-small-font-weight-inner)
  );
  --perxis-auto-header-parameters-toggler-letter-spacing-inner: var(
    --perxis-auto-header-parameters-toggler-letter-spacing,
    var(--perxis-auto-root-typography-small-letter-spacing-inner)
  );
  --perxis-auto-header-parameters-toggler-line-height-inner: var(
    --perxis-auto-header-parameters-toggler-line-height,
    var(--perxis-auto-root-typography-small-line-height-xxl-inner)
  );
  --perxis-auto-header-parameters-toggler-text-transform-inner: var(
    --perxis-auto-header-parameters-toggler-text-transform,
    var(--perxis-auto-root-typography-small-text-transform-inner)
  );
  /* End Typography */
  /* Icon */
  --perxis-auto-header-parameters-toggler-button-icon-color-inner: var(
    --perxis-auto-header-parameters-toggler-button-icon-color,
    var(--perxis-auto-root-second-color-inner)
  );
  --perxis-auto-header-parameters-toggler-button-hover-icon-color-inner: var(
    --perxis-auto-header-parameters-toggler-button-hover-icon-color,
    var(--perxis-auto-header-parameters-toggler-button-icon-color-inner)
  );
  --perxis-auto-header-parameters-toggler-button-icon-size-inner: var(
    --perxis-auto-header-parameters-toggler-button-icon-size,
    24px
  );
  --perxis-auto-header-parameters-toggler-open-button-icon-color-inner: var(
    --perxis-auto-header-parameters-toggler-open-button-icon-color,
    var(--perxis-auto-root-third-color-inner)
  );
  --perxis-auto-header-parameters-toggler-open-button-hover-icon-color-inner: var(
    --perxis-auto-header-parameters-toggler-open-button-hover-icon-color,
    var(--perxis-auto-header-parameters-toggler-open-button-icon-color-inner)
  );
  /* End Icon */
  /* Border */
  --perxis-auto-header-parameters-toggler-border-radius-inner: var(
    --perxis-auto-header-parameters-toggler-button-border-radius,
    0
  );
  /* End Border */
  display: inline-flex;
}
.perxis-auto-1_16_0-header-parameters-toggler .perxis-auto-1_16_0-button.perxis-auto-1_16_0-button-text {
  --perxis-auto-button-font-family: var(--perxis-auto-header-parameters-toggler-font-family-inner);
  --perxis-auto-button-font-size: var(--perxis-auto-header-parameters-toggler-font-size-inner);
  --perxis-auto-button-font-weight: var(--perxis-auto-header-parameters-toggler-font-weight-inner);
  --perxis-auto-button-letter-spacing: var(--perxis-auto-header-parameters-toggler-letter-spacing-inner);
  --perxis-auto-button-line-height: var(--perxis-auto-header-parameters-toggler-line-height-inner);
  --perxis-auto-button-text-transform: var(--perxis-auto-header-parameters-toggler-text-transform-inner);
  --perxis-auto-button-text-icon-color: var(--perxis-auto-header-parameters-toggler-button-icon-color-inner);
  --perxis-auto-button-text-icon-hover-color: var(
    --perxis-auto-header-parameters-toggler-button-hover-icon-color-inner
  );
  --perxis-auto-icon-font-size: var(--perxis-auto-header-parameters-toggler-button-icon-size-inner);
  --perxis-auto-button-border-radius-inner: var(--perxis-auto-header-parameters-toggler-border-radius-inner);
}
.perxis-auto-1_16_0-header-parameters-toggler.perxis-auto-1_16_0-header-parameters-toggler--open .perxis-auto-1_16_0-button.perxis-auto-1_16_0-button-text {
  --perxis-auto-button-text-icon-color: var(--perxis-auto-header-parameters-toggler-open-button-icon-color-inner);
  --perxis-auto-button-text-icon-hover-color: var(
    --perxis-auto-header-parameters-toggler-open-button-hover-icon-color-inner
  );
}
.perxis-auto-1_16_0-header-parameters-toggler__badge {
  /* Typography */
  --perxis-auto-header-parameters-toggler-badge-font-family-inner: var(
    --perxis-auto-header-parameters-toggler-badge-font-family,
    var(--perxis-auto-root-typography-marker-font-family-inner)
  );
  --perxis-auto-header-parameters-toggler-badge-font-size-inner: var(
    --perxis-auto-header-parameters-toggler-badge-font-size,
    var(--perxis-auto-root-typography-marker-font-size-xxl-inner)
  );
  --perxis-auto-header-parameters-toggler-badge-font-weight-inner: var(
    --perxis-auto-header-parameters-toggler-badge-font-weight,
    700
  );
  --perxis-auto-header-parameters-toggler-badge-font-variant-numeric-inner: var(
    --perxis-auto-header-parameters-toggler-badge-font-variant-numeric,
    var(--perxis-auto-root-typography-marker-font-variant-numeric-inner)
  );
  --perxis-auto-header-parameters-toggler-badge-letter-spacing-inner: var(
    --perxis-auto-header-parameters-toggler-badge-letter-spacing,
    0
  );
  --perxis-auto-header-parameters-toggler-badge-line-height-inner: var(
    --perxis-auto-header-parameters-toggler-badge-line-height,
    1
  );
  /* End Typography */
  /* Colors */
  --perxis-auto-header-parameters-toggler-badge-background-color-inner: var(
    --perxis-auto-header-parameters-toggler-badge-background-color,
    var(--perxis-auto-root-third-color-inner)
  );
  --perxis-auto-header-parameters-toggler-badge-border-color-inner: var(
    --perxis-auto-header-parameters-toggler-badge-border-color,
    var(--perxis-auto-root-third-color-inner)
  );
  --perxis-auto-header-parameters-toggler-badge-color-inner: var(
    --perxis-auto-header-parameters-toggler-badge-color,
    var(--perxis-auto-root-typography-color-lightest-inner)
  );
  /* End Colors */
  /* Border */
  --perxis-auto-header-parameters-toggler-badge-border-radius-inner: var(
    --perxis-auto-header-parameters-toggler-badge-border-radius,
    4px
  );
  --perxis-auto-header-parameters-toggler-badge-border-width-inner: var(
    --perxis-auto-header-parameters-toggler-badge-border-width,
    1px
  );
  /* End Border */
  /* Box Shadow */
  --perxis-auto-header-parameters-toggler-badge-box-shadow-inner: var(
    --perxis-auto-header-parameters-toggler-badge-box-shadow,
    none
  );
  /* End Box Shadow */
  /* Padding */
  --perxis-auto-header-parameters-toggler-badge-padding-inner: var(
    --perxis-auto-header-parameters-toggler-badge-padding,
    4px
  );
  /* End Padding */
  /* Sizes */
  --perxis-auto-header-parameters-toggler-badge-height-inner: var(
    --perxis-auto-header-parameters-toggler-badge-height,
    auto
  );
  --perxis-auto-header-parameters-toggler-badge-min-width-inner: var(
    --perxis-auto-header-parameters-toggler-badge-min-width,
    15px
  );
  /* End Sizes */
  --perxis-auto-badge-font-family-inner: var(--perxis-auto-header-parameters-toggler-badge-font-family-inner);
  --perxis-auto-badge-font-size-inner: var(--perxis-auto-header-parameters-toggler-badge-font-size-inner);
  --perxis-auto-badge-font-weight-inner: var(--perxis-auto-header-parameters-toggler-badge-font-weight-inner);
  --perxis-auto-badge-font-variant-numeric-inner: var(
    --perxis-auto-header-parameters-toggler-badge-font-variant-numeric-inner
  );
  --perxis-auto-badge-letter-spacing-inner: var(--perxis-auto-header-parameters-toggler-badge-letter-spacing-inner);
  --perxis-auto-badge-line-height-inner: var(--perxis-auto-header-parameters-toggler-badge-line-height-inner);
  --perxis-auto-badge-secondary-background-color-inner: var(
    --perxis-auto-header-parameters-toggler-badge-background-color-inner
  );
  --perxis-auto-badge-secondary-border-color-inner: var(
    --perxis-auto-header-parameters-toggler-badge-border-color-inner
  );
  --perxis-auto-badge-secondary-color-inner: var(--perxis-auto-header-parameters-toggler-badge-color-inner);
  --perxis-auto-badge-border-radius-inner: var(--perxis-auto-header-parameters-toggler-badge-border-radius-inner);
  --perxis-auto-badge-border-width-inner: var(--perxis-auto-header-parameters-toggler-badge-border-width-inner);
  --perxis-auto-badge-box-shadow-inner: var(--perxis-auto-header-parameters-toggler-badge-box-shadow-inner);
  --perxis-auto-badge-padding-inner: var(--perxis-auto-header-parameters-toggler-badge-padding-inner);
  --perxis-auto-badge-height-inner: var(--perxis-auto-header-parameters-toggler-badge-height-inner);
  --perxis-auto-badge-min-width-inner: var(--perxis-auto-header-parameters-toggler-badge-min-width-inner);
}

.perxis-auto-1_16_0-header-counter {
  display: inline-flex;
}

.perxis-auto-1_16_0-header-sort {
  /* Typography */
  --perxis-auto-header-sort-font-family-inner: var(
    --perxis-auto-header-sort-font-family,
    var(--perxis-auto-root-typography-font-family-inner)
  );
  --perxis-auto-header-sort-font-size-inner: var(--perxis-auto-header-sort-font-size, 14px);
  --perxis-auto-header-sort-first-font-weight-inner: var(--perxis-auto-header-sort-first-font-weight, 400);
  --perxis-auto-header-sort-second-font-weight-inner: var(--perxis-auto-header-sort-second-font-weight, 400);
  --perxis-auto-header-sort-line-height-inner: var(--perxis-auto-header-sort-line-height, 1);
  --perxis-auto-header-sort-letter-spacing-inner: var(--perxis-auto-header-sort-letter-spacing, 0.02em);
  --perxis-auto-header-sort-text-decoration-inner: var(--perxis-auto-header-sort-text-decoration, none);
  /* End Typography */
  /* Colors */
  --perxis-auto-header-sort-first-color-inner: var(
    --perxis-auto-header-sort-first-color,
    var(--perxis-auto-root-tenth-color-inner)
  );
  --perxis-auto-header-sort-second-color-inner: var(
    --perxis-auto-header-sort-second-color,
    var(--perxis-auto-root-second-color-inner)
  );
  /* End Colors */
  display: inline-flex;
}
.perxis-auto-1_16_0-header-sort .perxis-auto-1_16_0-dropdown-trigger.ant-5_17_0-dropdown-trigger {
  text-decoration: var(--perxis-auto-header-sort-text-decoration-inner);
}
.perxis-auto-1_16_0-header-sort .perxis-auto-1_16_0-dropdown-trigger.ant-5_17_0-dropdown-trigger .perxis-auto-1_16_0-dropdown-trigger__title {
  font-family: var(--perxis-auto-header-sort-font-family-inner);
  font-size: var(--perxis-auto-header-sort-font-size-inner);
  font-weight: var(--perxis-auto-header-sort-first-font-weight-inner);
  line-height: var(--perxis-auto-header-sort-line-height-inner);
  letter-spacing: var(--perxis-auto-header-sort-letter-spacing-inner);
  color: var(--perxis-auto-header-sort-first-color-inner);
}
.perxis-auto-1_16_0-header-sort .perxis-auto-1_16_0-dropdown-trigger.ant-5_17_0-dropdown-trigger .perxis-auto-1_16_0-dropdown-trigger__value {
  font-family: var(--perxis-auto-header-sort-font-family-inner);
  font-size: var(--perxis-auto-header-sort-font-size-inner);
  font-weight: var(--perxis-auto-header-sort-second-font-weight-inner);
  line-height: var(--perxis-auto-header-sort-line-height-inner);
  letter-spacing: var(--perxis-auto-header-sort-letter-spacing-inner);
  color: var(--perxis-auto-header-sort-second-color-inner);
}

.perxis-auto-1_16_0-header-back-button {
  /* Typography */
  --perxis-auto-header-back-button-font-family-inner: var(
    --perxis-auto-header-back-button-font-family,
    var(--perxis-auto-root-typography-small-font-family-inner)
  );
  --perxis-auto-header-back-button-font-size-inner: var(
    --perxis-auto-header-back-button-font-size,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  --perxis-auto-header-back-button-font-weight-inner: var(
    --perxis-auto-header-back-button-font-weight,
    var(--perxis-auto-root-typography-small-font-weight-inner)
  );
  --perxis-auto-header-back-button-letter-spacing-inner: var(
    --perxis-auto-header-back-button-letter-spacing,
    var(--perxis-auto-root-typography-small-letter-spacing-inner)
  );
  --perxis-auto-header-back-button-line-height-inner: var(
    --perxis-auto-header-back-button-line-height,
    var(--perxis-auto-root-typography-small-line-height-xxl-inner)
  );
  --perxis-auto-header-back-button-text-transform-inner: var(
    --perxis-auto-header-back-button-text-transform,
    var(--perxis-auto-root-typography-small-text-transform-inner)
  );
  /* End Typography */
  /* Icon */
  --perxis-auto-header-back-button-icon-color-inner: var(
    --perxis-auto-header-back-button-icon-color,
    var(--perxis-auto-root-fourth-color-inner)
  );
  --perxis-auto-header-back-button-icon-size-inner: var(--perxis-auto-header-back-button-icon-size, 24px);
  /* End Icon */
}
.perxis-auto-1_16_0-header-back-button .perxis-auto-1_16_0-button.perxis-auto-1_16_0-button-text {
  --perxis-auto-button-font-family: var(--perxis-auto-header-back-button-font-family-inner);
  --perxis-auto-button-font-size: var(--perxis-auto-header-back-button-font-size-inner);
  --perxis-auto-button-font-weight: var(--perxis-auto-header-back-button-font-weight-inner);
  --perxis-auto-button-letter-spacing: var(--perxis-auto-header-back-button-letter-spacing-inner);
  --perxis-auto-button-line-height: var(--perxis-auto-header-back-button-line-height-inner);
  --perxis-auto-button-text-transform: var(--perxis-auto-header-back-button-text-transform-inner);
  --perxis-auto-button-text-icon-color: var(--perxis-auto-header-back-button-icon-color-inner);
  --perxis-auto-icon-font-size: var(--perxis-auto-header-back-button-icon-size-inner);
}

.perxis-auto-1_16_0-header-car-info {
  /* Typography */
  --perxis-auto-header-car-info-title-font-family-inner: var(
    --perxis-auto-header-car-info-title-font-family,
    var(--perxis-auto-root-typography-h1-font-family-inner)
  );
  --perxis-auto-header-car-info-title-font-size-xxs-md-inner: var(
    --perxis-auto-header-car-info-title-font-size-xxs-md,
    28px
  );
  --perxis-auto-header-car-info-title-font-size-lg-inner: var(--perxis-auto-header-car-info-title-font-size-lg, 32px);
  --perxis-auto-header-car-info-title-font-size-xl-xxl-inner: var(
    --perxis-auto-header-car-info-title-font-size-xl-xxl,
    36px
  );
  --perxis-auto-header-car-info-title-text-transform-inner: var(
    --perxis-auto-header-car-info-title-text-transform,
    var(--perxis-auto-root-typography-h1-text-transform-inner)
  );
  --perxis-auto-header-car-info-title-font-weight-inner: var(
    --perxis-auto-header-car-info-title-font-weight,
    var(--perxis-auto-root-typography-h1-font-weight-inner)
  );
  --perxis-auto-header-car-info-title-color-inner: var(
    --perxis-auto-header-car-info-title-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  --perxis-auto-header-car-info-description-font-family-inner: var(
    --perxis-auto-header-car-info-description-font-family,
    var(--perxis-auto-root-typography-h1-font-family-inner)
  );
  --perxis-auto-header-car-info-description-font-size-inner: var(
    --perxis-auto-header-car-info-description-font-size,
    var(--perxis-auto-root-typography-h4-font-size-xxl-inner)
  );
  --perxis-auto-header-car-info-description-text-transform-inner: var(
    --perxis-auto-header-car-info-description-text-transform,
    var(--perxis-auto-root-typography-h4-text-transform-inner)
  );
  --perxis-auto-header-car-info-description-font-weight-inner: var(
    --perxis-auto-header-car-info-description-font-weight,
    400
  );
  --perxis-auto-header-car-info-description-color-inner: var(
    --perxis-auto-header-car-info-description-color,
    var(--perxis-auto-root-typography-color-dark-light-inner)
  );
  /* End Typography */
  --perxis-auto-header-car-info-padding-inner: var(
    --perxis-auto-header-car-info-padding,
    var(--perxis-auto-gap-vertical-purple-inner)
  );
  --perxis-auto-typography-h1-font-size-xxs: var(--perxis-auto-header-car-info-title-font-size-xxs-md-inner);
  --perxis-auto-typography-h1-font-size-xs: var(--perxis-auto-header-car-info-title-font-size-xxs-md-inner);
  --perxis-auto-typography-h1-font-size-sm: var(--perxis-auto-header-car-info-title-font-size-xxs-md-inner);
  --perxis-auto-typography-h1-font-size-md: var(--perxis-auto-header-car-info-title-font-size-xxs-md-inner);
  --perxis-auto-typography-h1-font-size-lg: var(--perxis-auto-header-car-info-title-font-size-lg-inner);
  --perxis-auto-typography-h1-font-size-xl: var(--perxis-auto-header-car-info-title-font-size-xl-xxl-inner);
  --perxis-auto-typography-h1-font-size-xxl: var(--perxis-auto-header-car-info-title-font-size-xl-xxl-inner);
  --perxis-auto-typography-h1-font-family: var(--perxis-auto-header-car-info-title-font-family-inner);
  --perxis-auto-typography-h1-text-transform: var(--perxis-auto-header-car-info-title-text-transform-inner);
  --perxis-auto-typography-h1-font-weight: var(--perxis-auto-header-car-info-title-font-weight-inner);
  --perxis-auto-typography-color-darkest: var(--perxis-auto-header-car-info-title-color-inner);
  --perxis-auto-typography-h4-font-size-xxs: var(--perxis-auto-header-car-info-description-font-size-inner);
  --perxis-auto-typography-h4-font-size-xs: var(--perxis-auto-header-car-info-description-font-size-inner);
  --perxis-auto-typography-h4-font-size-sm: var(--perxis-auto-header-car-info-description-font-size-inner);
  --perxis-auto-typography-h4-font-size-md: var(--perxis-auto-header-car-info-description-font-size-inner);
  --perxis-auto-typography-h4-font-size-lg: var(--perxis-auto-header-car-info-description-font-size-inner);
  --perxis-auto-typography-h4-font-size-xl: var(--perxis-auto-header-car-info-description-font-size-inner);
  --perxis-auto-typography-h4-font-size-xxl: var(--perxis-auto-header-car-info-description-font-size-inner);
  --perxis-auto-typography-h4-font-family: var(--perxis-auto-header-car-info-description-font-family-inner);
  --perxis-auto-typography-h4-text-transform: var(--perxis-auto-header-car-info-description-text-transform-inner);
  --perxis-auto-typography-h4-font-weight: var(--perxis-auto-header-car-info-description-font-weight-inner);
  --perxis-auto-typography-color-dark-light: var(--perxis-auto-header-car-info-description-color-inner);
  gap: var(--perxis-auto-header-car-info-padding-inner) 0;
  text-align: center;
}

.perxis-auto-1_16_0-header-counter-button {
  /* Typography */
  --perxis-auto-header-counter-button-font-family-inner: var(
    --perxis-auto-header-counter-button-font-family,
    var(--perxis-auto-root-typography-small-font-family-inner)
  );
  --perxis-auto-header-counter-button-font-size-inner: var(
    --perxis-auto-header-counter-button-font-size,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  --perxis-auto-header-counter-button-font-weight-inner: var(
    --perxis-auto-header-counter-button-font-weight,
    var(--perxis-auto-root-typography-small-font-weight-inner)
  );
  --perxis-auto-header-counter-button-letter-spacing-inner: var(
    --perxis-auto-header-counter-button-letter-spacing,
    var(--perxis-auto-root-typography-small-letter-spacing-inner)
  );
  --perxis-auto-header-counter-button-line-height-inner: var(
    --perxis-auto-header-counter-button-line-height,
    var(--perxis-auto-root-typography-small-line-height-xxl-inner)
  );
  --perxis-auto-header-counter-button-text-transform-inner: var(
    --perxis-auto-header-counter-button-text-transform,
    var(--perxis-auto-root-typography-small-text-transform-inner)
  );
  --perxis-auto-header-counter-button-badge-font-weight-inner: var(
    --perxis-auto-header-counter-button-badge-font-weight,
    700
  );
  /* End Typography */
  /* Sizes */
  --perxis-auto-header-counter-button-badge-min-width-inner: var(
    --perxis-auto-header-counter-button-badge-min-width,
    none
  );
  /* End Sizes */
  /* Padding */
  --perxis-auto-header-counter-button-badge-padding-inner: var(--perxis-auto-header-counter-button-badge-padding, 4px);
  /* End Padding */
  /* Border */
  --perxis-auto-header-counter-button-badge-border-radius-inner: var(
    --perxis-auto-header-counter-button-badge-border-radius,
    4px
  );
  /* End Border */
  /* Icon */
  --perxis-auto-header-counter-button-icon-color-inner: var(
    --perxis-auto-header-counter-button-icon-color,
    var(--perxis-auto-root-second-color-inner)
  );
  --perxis-auto-header-counter-button-hover-icon-color-inner: var(
    --perxis-auto-header-counter-button-hover-icon-color,
    var(--perxis-auto-root-third-color-inner)
  );
  --perxis-auto-header-counter-button-icon-size-inner: var(--perxis-auto-header-counter-button-icon-size, 24px);
  /* End Icon */
  display: inline-flex;
}
.perxis-auto-1_16_0-header-counter-button.perxis-auto-1_16_0-button.perxis-auto-1_16_0-button-text {
  --perxis-auto-button-font-family: var(--perxis-auto-header-counter-button-font-family-inner);
  --perxis-auto-button-font-size: var(--perxis-auto-header-counter-button-font-size-inner);
  --perxis-auto-button-font-weight: var(--perxis-auto-header-counter-button-font-weight-inner);
  --perxis-auto-button-letter-spacing: var(--perxis-auto-header-counter-button-letter-spacing-inner);
  --perxis-auto-button-line-height: var(--perxis-auto-header-counter-button-line-height-inner);
  --perxis-auto-button-text-transform: var(--perxis-auto-header-counter-button-text-transform-inner);
  --perxis-auto-button-text-icon-color: var(--perxis-auto-header-counter-button-icon-color-inner);
  --perxis-auto-button-text-icon-hover-color: var(--perxis-auto-header-counter-button-hover-icon-color-inner);
  --perxis-auto-icon-font-size: var(--perxis-auto-header-counter-button-icon-size-inner);
}
.perxis-auto-1_16_0-header-counter-button .perxis-auto-1_16_0-header-counter-button__badge {
  --perxis-auto-badge-font-weight: var(--perxis-auto-header-counter-button-badge-font-weight-inner);
  --perxis-auto-badge-border-radius: var(--perxis-auto-header-counter-button-badge-border-radius-inner);
  --perxis-auto-badge-min-width: var(--perxis-auto-header-counter-button-badge-min-width-inner);
  --perxis-auto-badge-padding: var(--perxis-auto-header-counter-button-badge-padding-inner);
  order: -1;
  margin: 0 0 0 8px !important;
}
@media (max-width: 576px) {
  .perxis-auto-1_16_0-header-counter-button > *:not(.perxis-auto-1_16_0-header-counter-button__badge):not(.ant-5_17_0-btn-icon) {
    display: none;
  }
}

.perxis-auto-1_16_0-header-link {
  /* Typography */
  --perxis-auto-header-link-font-family-inner: var(
    --perxis-auto-header-link-font-family,
    var(--perxis-auto-root-typography-small-font-family-inner)
  );
  --perxis-auto-header-link-font-size-inner: var(
    --perxis-auto-header-link-font-size,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  --perxis-auto-header-link-font-weight-inner: var(
    --perxis-auto-header-link-font-weight,
    var(--perxis-auto-root-typography-small-font-weight-inner)
  );
  --perxis-auto-header-link-letter-spacing-inner: var(
    --perxis-auto-header-link-letter-spacing,
    var(--perxis-auto-root-typography-small-letter-spacing-inner)
  );
  --perxis-auto-header-link-line-height-inner: var(
    --perxis-auto-header-link-line-height,
    var(--perxis-auto-root-typography-small-line-height-xxl-inner)
  );
  --perxis-auto-header-link-text-transform-inner: var(
    --perxis-auto-header-link-text-transform,
    var(--perxis-auto-root-typography-small-text-transform-inner)
  );
  /* End Typography */
  /* Icon */
  --perxis-auto-header-link-icon-color-inner: var(
    --perxis-auto-header-link-icon-color,
    var(--perxis-auto-root-fourth-color-inner)
  );
  --perxis-auto-header-link-icon-active-color-inner: var(
    --perxis-auto-header-link-icon-active-color,
    var(--perxis-auto-root-third-color-inner)
  );
  --perxis-auto-header-link-icon-size-inner: var(--perxis-auto-header-link-icon-size, 24px);
  /* End Icon */
}
.perxis-auto-1_16_0-header-link.perxis-auto-1_16_0-button.perxis-auto-1_16_0-button-text {
  --perxis-auto-button-font-family: var(--perxis-auto-header-link-font-family-inner);
  --perxis-auto-button-font-size: var(--perxis-auto-header-link-font-size-inner);
  --perxis-auto-button-font-weight: var(--perxis-auto-header-link-font-weight-inner);
  --perxis-auto-button-letter-spacing: var(--perxis-auto-header-link-letter-spacing-inner);
  --perxis-auto-button-line-height: var(--perxis-auto-header-link-line-height-inner);
  --perxis-auto-button-text-transform: var(--perxis-auto-header-link-text-transform-inner);
  --perxis-auto-button-text-icon-color: var(--perxis-auto-header-link-icon-color-inner);
  --perxis-auto-button-text-icon-hover-color: var(--perxis-auto-header-link-icon-color-inner);
  --perxis-auto-icon-font-size: var(--perxis-auto-header-link-icon-size-inner);
}
.perxis-auto-1_16_0-header-link.perxis-auto-1_16_0-button.perxis-auto-1_16_0-button-text.perxis-auto-1_16_0-header-link--active {
  --perxis-auto-button-text-icon-color: var(--perxis-auto-header-link-icon-active-color-inner);
  --perxis-auto-button-text-icon-hover-color: var(--perxis-auto-header-link-icon-active-color-inner);
}

.perxis-auto-1_16_0-header-heading {
  /* Typography */
  --perxis-auto-header-heading-title-font-family-inner: var(
    --perxis-auto-header-heading-title-font-family,
    var(--perxis-auto-root-typography-h1-font-family-inner)
  );
  --perxis-auto-header-heading-title-font-size-xxs-md-inner: var(
    --perxis-auto-header-heading-title-font-size-xxs-md,
    28px
  );
  --perxis-auto-header-heading-title-font-size-lg-inner: var(--perxis-auto-header-heading-title-font-size-lg, 32px);
  --perxis-auto-header-heading-title-font-size-xl-xxl-inner: var(
    --perxis-auto-header-heading-title-font-size-xl-xxl,
    36px
  );
  --perxis-auto-header-heading-title-text-transform-inner: var(
    --perxis-auto-header-heading-title-text-transform,
    var(--perxis-auto-root-typography-h1-text-transform-inner)
  );
  --perxis-auto-header-heading-title-font-weight-inner: var(
    --perxis-auto-header-heading-title-font-weight,
    var(--perxis-auto-root-typography-h1-font-weight-inner)
  );
  --perxis-auto-header-heading-title-color-inner: var(
    --perxis-auto-header-heading-title-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  --perxis-auto-header-heading-description-font-family-inner: var(
    --perxis-auto-header-heading-description-font-family,
    var(--perxis-auto-root-typography-h1-font-family-inner)
  );
  --perxis-auto-header-heading-description-font-size-inner: var(
    --perxis-auto-header-heading-description-font-size,
    var(--perxis-auto-root-typography-h4-font-size-xxl-inner)
  );
  --perxis-auto-header-heading-description-text-transform-inner: var(
    --perxis-auto-header-heading-description-text-transform,
    var(--perxis-auto-root-typography-h4-text-transform-inner)
  );
  --perxis-auto-header-heading-description-font-weight-inner: var(
    --perxis-auto-header-heading-description-font-weight,
    400
  );
  --perxis-auto-header-heading-description-color-inner: var(
    --perxis-auto-header-heading-description-color,
    var(--perxis-auto-root-typography-color-dark-light-inner)
  );
  /* End Typography */
  --perxis-auto-header-heading-gap-inner: var(
    --perxis-auto-header-heading-gap,
    var(--perxis-auto-gap-vertical-purple-inner) 0
  );
  --perxis-auto-typography-h1-font-size-xxs: var(--perxis-auto-header-heading-title-font-size-xxs-md-inner);
  --perxis-auto-typography-h1-font-size-xs: var(--perxis-auto-header-heading-title-font-size-xxs-md-inner);
  --perxis-auto-typography-h1-font-size-sm: var(--perxis-auto-header-heading-title-font-size-xxs-md-inner);
  --perxis-auto-typography-h1-font-size-md: var(--perxis-auto-header-heading-title-font-size-xxs-md-inner);
  --perxis-auto-typography-h1-font-size-lg: var(--perxis-auto-header-heading-title-font-size-lg-inner);
  --perxis-auto-typography-h1-font-size-xl: var(--perxis-auto-header-heading-title-font-size-xl-xxl-inner);
  --perxis-auto-typography-h1-font-size-xxl: var(--perxis-auto-header-heading-title-font-size-xl-xxl-inner);
  --perxis-auto-typography-h1-font-family: var(--perxis-auto-header-heading-title-font-family-inner);
  --perxis-auto-typography-h1-text-transform: var(--perxis-auto-header-heading-title-text-transform-inner);
  --perxis-auto-typography-h1-font-weight: var(--perxis-auto-header-heading-title-font-weight-inner);
  --perxis-auto-typography-color-darkest: var(--perxis-auto-header-heading-title-color-inner);
  --perxis-auto-typography-h4-font-size-xxs: var(--perxis-auto-header-heading-description-font-size-inner);
  --perxis-auto-typography-h4-font-size-xs: var(--perxis-auto-header-heading-description-font-size-inner);
  --perxis-auto-typography-h4-font-size-sm: var(--perxis-auto-header-heading-description-font-size-inner);
  --perxis-auto-typography-h4-font-size-md: var(--perxis-auto-header-heading-description-font-size-inner);
  --perxis-auto-typography-h4-font-size-lg: var(--perxis-auto-header-heading-description-font-size-inner);
  --perxis-auto-typography-h4-font-size-xl: var(--perxis-auto-header-heading-description-font-size-inner);
  --perxis-auto-typography-h4-font-size-xxl: var(--perxis-auto-header-heading-description-font-size-inner);
  --perxis-auto-typography-h4-font-family: var(--perxis-auto-header-heading-description-font-family-inner);
  --perxis-auto-typography-h4-text-transform: var(--perxis-auto-header-heading-description-text-transform-inner);
  --perxis-auto-typography-h4-font-weight: var(--perxis-auto-header-heading-description-font-weight-inner);
  --perxis-auto-typography-color-dark-light: var(--perxis-auto-header-heading-description-color-inner);
  gap: var(--perxis-auto-header-heading-gap-inner);
  text-align: center;
}

.perxis-auto-1_16_0-header-status {
  width: 100%;
  max-width: 100%;
  display: flex;
  justify-content: flex-end;
}
.perxis-auto-1_16_0-header-status .perxis-auto-1_16_0-header-status__content {
  width: fit-content;
  max-width: 100%;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
